import type { SearchParams } from '@features/partnerships/context/partnerships-wizard-types';

const DEFAULT_PORTALS = ['vivareal', 'zapimoveis', 'olx'];

/**
 * Returns the trimmed value, or `undefined` when it is an empty string.
 */
function orUndefined(value: string): string | undefined {
  return value ? value : undefined;
}

/**
 * Builds normalized partnership search parameters from form fields.
 *
 * Portals are always sent as a fixed default (portal-independent to the user).
 */
export function buildSearchParams(
  city: string,
  neighborhood: string,
  propertyType: string,
  transaction: string,
  bedrooms: string,
  priceMin: number | undefined,
  priceMax: number | undefined,
): SearchParams {
  return {
    city: city.trim(),
    neighbourhood: orUndefined(neighborhood.trim()),
    property_type: orUndefined(propertyType),
    transaction: orUndefined(transaction),
    bedrooms: bedrooms ? Number(bedrooms) : undefined,
    price_min: priceMin,
    price_max: priceMax,
    portals: DEFAULT_PORTALS,
  };
}
